import React, { useState } from "react";
import './Feature.scss';
import { Button } from "antd";

const Feature = ({ features, title, subtitle, theme }) => {
  const [showAll, setShowAll] = useState(false);
  const INITIAL_DISPLAY_COUNT = 6;
  
  const shouldShowToggle = features.length > INITIAL_DISPLAY_COUNT;
  const displayedFeatures = showAll ? features : features.slice(0, INITIAL_DISPLAY_COUNT);

  return (
    <section id={title.toLowerCase()} className={`feature feature-theme-${theme}`}>
      <div className="feature-container">
        <div className="feature-header">
          <h2 className="feature-title">{title}</h2>
          <p className="feature-subtitle">{subtitle}</p>
        </div>

        <div className="feature-grid">
          {displayedFeatures.map((feature) => (
            <div key={feature.id} className="feature-card">
              <div className="card-image-container">
                <img
                  src={feature.images?.[0]?.file || "/placeholder.svg"}
                  alt={feature.title}
                  className="card-image"
                />
              </div>
              <div className="card-content">
                <h3 className="card-title">{feature.title}</h3>
                <p className="card-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {shouldShowToggle && (
          <div className="feature-toggle">
            <button 
              onClick={() => setShowAll(!showAll)}
              className="toggle-button"
            >
              {showAll ? 'Show Less' : 'Show More'}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Feature;